import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { cigaroUser } from "../models/user";
import { AuthService } from "../services/auth.service";

@Injectable()
export class JWTInterceptor implements HttpInterceptor{
  constructor(private as:AuthService){

  }


  intercept(req: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {
    const user:cigaroUser|boolean=this.as.getCigaroUser();
      if (user!==null && typeof(user)!=="undefined" && typeof(user.token)!=="undefined") {
        const cloned = req.clone({headers: req.headers.set("Authorization","Bearer "
         + user.token)});
        return next.handle(cloned);
      }
      else{
        return next.handle(req);
      }
  }
}
